module.exports = __webpack_public_path__ + "img/delfi-logo.06f5d1e7.png";